import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/yk/Dev/BaseballDataViewer/nextjs/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/yk/Dev/BaseballDataViewer/nextjs/styles/InfoPage.css");
;
import(/* webpackMode: "eager" */ "/Users/yk/Dev/BaseballDataViewer/nextjs/styles/Player.css");
;
import(/* webpackMode: "eager" */ "/Users/yk/Dev/BaseballDataViewer/nextjs/styles/International.css");
